import IconComponent from "icons/IconComponent";

import ClockFive from "./clock-five.svg";

export default (ClockFive as any) as IconComponent;
